import React from 'react';
import Thead from "components/table/components/thead";
import ScrollableTableWrapper from "components/table/components/ScrollableTableWrapper";

import Tbodyhours
    from "components/table/components/tbodyhours";
const Table = ({champsHeader, champsBody, isWaiting, searchValue, searchType}) => {

    return (
        <ScrollableTableWrapper className="overflow-y-visible w-full">
            <table className={`jbz-table table-auto w-full min-w-[1200px] text-gray-500 space-y-6 ft-sm ${isWaiting ? 'animate-pulse' : ''}`}>
                <thead className="sticky top-0 z-10">
                <Thead champsHeader={champsHeader} isWaiting={isWaiting}/>
                </thead>
                <tbody>
                {
                    isWaiting ? (
                        <>
                            {[1, 2, 3, 4, 5].map((i, index) => (
                                <tr key={index}>
                                    {/* N° de relevé */}
                                    <td className="py-5 pl-4 pr-2">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* MISSION */}
                                    <td className="py-5 px-2">
                                        <div className="space-y-2">
                                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                                            <div className="h-3 bg-gray-200 rounded w-2/3"></div>
                                        </div>
                                    </td>
                                    {/* Intérimaire */}
                                    <td className="py-5 px-2">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* période */}
                                    <td className="py-5 px-2">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* Badge status */}
                                    <td className="py-5 px-2">
                                        <div className="h-6 bg-gray-200 rounded w-20 mx-auto"></div>
                                    </td>
                                    {/* Button */}
                                    <td className="py-5 pl-2 pr-3">
                                        <div className="h-8 w-8 bg-gray-200 rounded mx-auto"></div>
                                    </td>
                                </tr>
                            ))}
                        </>
                    ) : (
                        <>
                            <Tbodyhours champsBody={champsBody}/>
                        </>
                    )
                }
                </tbody>
            </table>
        </ScrollableTableWrapper>
    );
};

export default Table;